import React, { forwardRef, useEffect, useImperativeHandle, useReducer } from 'react';

const ParentControlled = forwardRef(({ initial, reducer, ...props }, ref) => {
	const intern_reducer = (state,action) => {
		switch (action.type) {
			case 'INTERN_SET_INITIAL':
				return {...action.initial};
			default:
				return reducer(state,action);
		}
	}
	
	const [state, interndispatch] = useReducer(intern_reducer, initial);

	useImperativeHandle(ref, () => ({
		dispatch(action) {
			interndispatch(action);
		}
	}), []);

	useEffect(() => {
		interndispatch({type:'INTERN_SET_INITIAL',initial})
	},[initial])

	return React.cloneElement(props.children, { ...state });
});

export default ParentControlled;